import {componentTemplate} from './rptemplate';
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { DNDContainer } from './dnd/DNDContainer.js';

function ResponsePage({
  colorFont,
  colorBackground,
  components = componentTemplate,
  setComponents,
  setSelectedComponentIndex,
  language = "en",
}) {
  return (
    <div
      id="responsepage"
      style={{
        color: colorFont.value,
        backgroundColor: colorBackground.value,
        border: "1px solid lightgray",
        height: "100%",
        fontFamily: "Open Sans",
        width: "100%",
        overflow: "scroll"
      }}
    >
      <noscript style={{
        textAlign: "center",
        color: "red",
        fontFamily: "Open Sans Bold"
      }}>
        {'{noscripttext}'}
      </noscript>
      <DndProvider backend={HTML5Backend}>
        <DNDContainer
          cards={components}
          setComponents={setComponents}
          language={language}
          setSelectedComponentIndex={setSelectedComponentIndex}
        />
      </DndProvider>
    </div>
  );
}

export default ResponsePage;